<template>
  <v-list
    class="p-0"
    elevation="0"
    open-strategy="single"
  >
    <template
      v-for="(item, index) in items"
      :key="index"
    >
      <template v-if="item.mainLinks.length">
        <v-list-group :value="item.mainLink.text">
          <template #activator="{ props }">
            <v-defaults-provider :defaults="{ VListItemTitle: { class: 'text-body-sm font-bold' } }">
              <v-list-item
                v-bind="props"
                active-class="bg-black-4"
                height="48"
                :title="item.mainLink.text"
              />
            </v-defaults-provider>
          </template>

          <slot :menu="item" />
        </v-list-group>
      </template>
      <template v-else>
        <v-list-item v-bind="item.mainLink" />
      </template>
    </template>
  </v-list>
</template>

<script setup lang="ts">
defineProps<{
  items?: any
}>()
</script>
